import { z } from 'zod'

export const GetPlaceAddressBookSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const GetPlaceSchema = z.object({
  // address_book: GetPlaceAddressBookSchema.nullish(),
  address_id: z.number().nullish(),
  city: z.string().nullish(),
  country: z.string(),
  country_code: z.string(),
  formattedAddress: z.string().nullish(),
  lat: z.string().nullish(),
  lng: z.string().nullish(),
  name: z.string().nullish(),
  place_id: z.string().nullish(),
  place_name: z.string().nullish(),
  postcode: z.string().nullish(),
})
